import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function OtpChallengeForm({ challenge, code, onCodeChange, submitting, onSubmit, onCancel }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="otp-challenge-form">
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm">
        <p className="font-semibold text-amber-900">Sign-in from {challenge.country_label || 'a new location'}</p>
        <p className="text-amber-800 mt-1">
          This account is geo-restricted. We sent a 6-digit code to <strong>{challenge.hint}</strong>. Enter it below — or just tap <em>&ldquo;Approve this sign-in&rdquo;</em> in the email if you&rsquo;re reading it on your phone (this page will sign you in automatically). Code expires in {challenge.expires_in_minutes ?? 10} minutes.
        </p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="otp" className="uppercase tracking-wide text-xs text-muted-foreground">Verification Code</Label>
        <Input
          id="otp"
          data-testid="otp-code-input"
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="[0-9]{6}"
          maxLength={6}
          placeholder="000000"
          value={code}
          onChange={(e) => onCodeChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
          required
          className="h-14 bg-muted/50 text-center text-2xl font-mono tracking-[0.4em]"
          autoFocus
        />
      </div>
      <Button type="submit" className="w-full h-12 font-semibold" disabled={submitting || code.length !== 6} data-testid="otp-submit-button">
        {submitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Verifying…</> : 'Verify and sign in'}
      </Button>
      <Button type="button" variant="ghost" className="w-full" onClick={onCancel} data-testid="otp-cancel-button">
        Cancel and try a different account
      </Button>
    </form>
  );
}
